import React, { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";

import WaitingApplication from "./views/new/WaitingApplication";
import LoadingPage from "./views/LoadingPage";
import {
  commonRoutes,
  existingCustomerRoutes,
  newCustomerRoutes,
} from "./constants/routes";
import AppLocale from "./lang";
import "./App.css";
import "./assets/css/classes.css";

const CrediteaPayIntroduction = lazy(
  () => import("./views/CrediteaPayIntroduction")
);
const CustomerData = lazy(() => import("./views/CustomerData"));
const CustomerDataBasic = lazy(() => import("./views/CustomerDataBasic"));
const OTPCheck = lazy(() => import("./views/existing/OTPCheck"));
const OTPSuccess = lazy(() => import("./views/existing/OTPSuccess"));
const DrawSimulation = lazy(() => import("./views/existing/DrawSimulation"));
const PersonalData = lazy(
  () => import("./views/new/CustomerDataDetailed/PersonalData")
);
const ResidentialAddress = lazy(
  () => import("./views/new/CustomerDataDetailed/ResidentialAddress")
);
const EmploymentData = lazy(
  () => import("./views/new/CustomerDataDetailed/EmploymentData")
);
const ApplicationConfirmation = lazy(
  () => import("./views/new/ApplicationConfirmation")
);
const OfferAvailable = lazy(() => import("./views/new/OfferAvailable"));
const MaxOfferAvailable = lazy(() => import("./views/new/MaxOfferAvailable"));
const OfferAvailablePending = lazy(
  () => import("./views/new/OfferAvailablePending")
);
const DebitCardRegistration = lazy(
  () => import("./views/new/DebitCardRegistration")
);
const DebitCardRegistrationSuccess = lazy(
  () => import("./views/new/DebitCardRegistrationSuccess")
);
const IdentityVerification = lazy(
  () => import("./views/new/IdentityVerification")
);
const OnfidoVerification = lazy(() => import("./views/new/OnfidoVerification"));
const OnfidoVerificationSuccess = lazy(
  () => import("./views/new/OnfidoVerificationSuccess")
);
const SubmitingPage = lazy(() => import("./views/new/SubmitingPage"));
const WaitingPage = lazy(() => import("./views/new/WaitingPage"));
const NegativeDrawSimulation = lazy(
  () => import("./views/existing/NegativeDrawSimulation")
);
const FieldRequired = lazy(() => import("./views/new/FieldRequired"));
const TimeUp = lazy(() => import("./views/TimeUp"));
const UploadFiles = lazy(() => import("./views/new/UploadFiles"));
const SuccessPage = lazy(() => import("./views/SuccessPage"));
const PaymentFailed = lazy(() => import("./views/PaymentFailed"));
const PaymentConfirmationError = lazy(
  () => import("./views/PaymentConfirmationError")
);
const SorryPage = lazy(() => import("./views/SorryPage"));
const WrongDataRejection = lazy(() => import("./views/WrongDataRejection"));
const ReturnHome = lazy(() => import("./views/ReturnHome"));
const ErrorPage = lazy(() => import("./views/ErrorPage"));
const NotFoundPage = lazy(() => import("./views/NotFoundPage"));
const QrPage = lazy(() => import("./views/QrPage"));
const QrExpired = lazy(() => import("./views/QrExpired"));
const Widget = lazy(() => import("./views/Widget"));
const MerchantConfiguration = lazy(
  () => import("./views/MerchantConfiguration")
);
const JWTStorageManager = lazy(() => import("./components/JWTStorageManager"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const RedirectLastSavedRoute = lazy(
  () => import("./components/RedirectLastSavedRoute")
);
const SocketConnectionRoute = lazy(
  () => import("./components/SocketConnectionRoute")
);

class App extends React.Component {
  render() {
    const currentAppLocale = AppLocale["es"];

    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <ScrollToTop>
            <Routes>
              <Route element={<RedirectLastSavedRoute />}>
                <Route element={<JWTStorageManager />}>
                  <Route
                    path={commonRoutes.LoadingPage}
                    element={<LoadingPage />}
                  />
                </Route>
                <Route
                  path={commonRoutes.CrediteaPayIntroduction}
                  element={<CrediteaPayIntroduction />}
                />
                <Route
                  path={commonRoutes.CustomerData}
                  element={<CustomerData />}
                />
                <Route
                  path={commonRoutes.CustomerDataBasic}
                  element={<CustomerDataBasic />}
                />
                <Route
                  path={existingCustomerRoutes.OTPCheck}
                  element={<OTPCheck />}
                />
                <Route
                  path={existingCustomerRoutes.OTPSuccess}
                  element={<OTPSuccess />}
                />
                <Route
                  path={existingCustomerRoutes.DrawSimulation}
                  element={<DrawSimulation />}
                />
                <Route
                  path={newCustomerRoutes.CustomerDataDetailed.PersonalData}
                  element={<PersonalData />}
                />
                <Route
                  path={
                    newCustomerRoutes.CustomerDataDetailed.ResidentialAddress
                  }
                  element={<ResidentialAddress />}
                />
                <Route
                  path={newCustomerRoutes.CustomerDataDetailed.EmploymentData}
                  element={<EmploymentData />}
                />
                <Route
                  path={newCustomerRoutes.ApplicationConfirmation}
                  element={<ApplicationConfirmation />}
                />
                <Route
                  path={newCustomerRoutes.OfferAvailable}
                  element={<OfferAvailable />}
                />
                <Route
                  path={newCustomerRoutes.OfferAvailablePending}
                  element={<OfferAvailablePending />}
                />
                <Route
                  path={newCustomerRoutes.MaxOfferAvailable}
                  element={<MaxOfferAvailable />}
                />
                <Route element={<SocketConnectionRoute />}>
                  <Route
                    path={newCustomerRoutes.DebitCardRegistration}
                    element={<DebitCardRegistration />}
                  />
                  <Route
                    path={newCustomerRoutes.DebitCardRegistrationSuccess}
                    element={<DebitCardRegistrationSuccess />}
                  />
                  <Route
                    path={newCustomerRoutes.IdentityVerification}
                    element={<IdentityVerification />}
                  />
                  <Route
                    path={newCustomerRoutes.OnfidoVerification}
                    element={<OnfidoVerification />}
                  />
                  <Route
                    path={newCustomerRoutes.OnfidoVerificationPending}
                    element={<WaitingApplication />}
                  />
                </Route>
                <Route
                  path={newCustomerRoutes.OnfidoVerificationSuccess}
                  element={<OnfidoVerificationSuccess />}
                />
                <Route
                  path={newCustomerRoutes.SubmitingPage}
                  element={<SubmitingPage />}
                />
                <Route
                  path={newCustomerRoutes.WaitingPage}
                  element={<WaitingPage />}
                />
                <Route
                  path={existingCustomerRoutes.NegativeDrawSimulation}
                  element={<NegativeDrawSimulation />}
                />
                <Route
                  path={newCustomerRoutes.FieldRequired}
                  element={<FieldRequired />}
                />
                <Route path={commonRoutes.TimeUp} element={<TimeUp />} />
                <Route
                  path={newCustomerRoutes.UploadFiles}
                  element={<UploadFiles />}
                />
                <Route
                  path={commonRoutes.SuccessPage}
                  element={<SuccessPage />}
                />
                <Route
                  path={commonRoutes.PaymentFailed}
                  element={<PaymentFailed />}
                />
                <Route
                  path={commonRoutes.PaymentConfirmationError}
                  element={<PaymentConfirmationError />}
                />
                <Route path={commonRoutes.SorryPage} element={<SorryPage />} />
                <Route
                  path={commonRoutes.WrongDataRejection}
                  element={<WrongDataRejection />}
                />
                <Route
                  path={commonRoutes.ReturnHome}
                  element={<ReturnHome />}
                />
                <Route path={commonRoutes.ErrorPage} element={<ErrorPage />} />
              </Route>
              <Route path={commonRoutes.QrPage} element={<QrPage />} />
              <Route path={commonRoutes.QrExpired} element={<QrExpired />} />
              <Route path={commonRoutes.Widget} element={<Widget />} />
              <Route
                path={commonRoutes.MerchantConfiguration}
                element={<MerchantConfiguration />}
              />
              <Route
                path={commonRoutes.NotFoundPage}
                element={<NotFoundPage />}
              />
            </Routes>
          </ScrollToTop>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}

export default App;
